import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'eview-post-public-comment',
  templateUrl: 'post-public-comment.component.html',
  styleUrls: ['post-public-comment.component.scss']
})
export class PostPublicCommentComponent implements OnInit, OnDestroy {
  @Input() commentList: any[] | null = [];
  /** Form grant `comment` for this report's form. */
  @Input() canComment = false;
  /** Delete published comments (comment or edit_any grant). */
  @Input() canDeleteComments = false;
  /** @deprecated use canDeleteComments */
  @Input() set viewOnlyMode(v: boolean) {
    if (v) {
      this.canDeleteComments = true;
    }
  }
  @Output() public onDeleteClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPostClick: EventEmitter<any> = new EventEmitter();
  commentFormGroup: UntypedFormGroup;
  submitted = false;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    // no-op (keeps hybrid/mobile implementable interfaces aligned)
  }

  get list(): any[] {
    return Array.isArray(this.commentList) ? this.commentList : [];
  }

  /** Show panel if user can add or there are comments to read. */
  get showPanel(): boolean {
    return this.canComment || this.list.length > 0;
  }

  initForm() {
    this.commentFormGroup = this.fb.group({
      comment: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(255)
      ])
    });
  }

  get control() {
    return this.commentFormGroup.controls;
  }

  onSubmit() {
    if (!this.canComment) {
      return;
    }
    this.submitted = true;
    if (this.commentFormGroup.valid) {
      this.onPostClick.emit(this.commentFormGroup.value);
      this.submitted = false;
      this.commentFormGroup.reset();
    }
  }
}
